export default __webpack_public_path__ + "static/media/cancel.b98ab810.png";